import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(email, password);
      if (result.success) {
        toast.success('Logged in successfully');
        navigate('/admin');
      } else {
        toast.error(result.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center justify-center" data-testid="admin-login-page">
      <div className="max-w-md w-full mx-4">
        <div className="text-center mb-8">
          <Lock className="w-10 h-10 mx-auto text-[#C29B57] mb-4" />
          <h1 className="font-cormorant text-4xl sm:text-5xl mb-2" data-testid="admin-login-heading">Admin Login</h1>
          <p className="font-outfit text-sm text-[#8C8577]">Access the admin panel</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <input
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border-b border-[#EBE4D5] bg-transparent rounded-none px-0 py-2 focus:ring-0 focus:border-[#C29B57] font-outfit text-base placeholder:text-[#8C8577] transition-colors outline-none"
              data-testid="email-input"
            />
          </div>
          
          <div>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border-b border-[#EBE4D5] bg-transparent rounded-none px-0 py-2 focus:ring-0 focus:border-[#C29B57] font-outfit text-base placeholder:text-[#8C8577] transition-colors outline-none"
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1A1A18] text-white hover:bg-[#C29B57] transition-colors duration-300 rounded-none px-8 py-4 font-outfit uppercase tracking-wider text-sm disabled:opacity-50"
            data-testid="submit-button"
          >
            {loading ? 'Please wait...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
